import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PropositionStatus } from './proposition-status.interface';
import { PropositionStatusService } from './proposition-status.service';

const service = new PropositionStatusService();

export interface PropositionStatusState {
   propositionStatuses: Array<PropositionStatus>;
}

const PropositionStatusStore: Module<PropositionStatusState, StoreState> = {
   namespaced: true,
   state: {
      propositionStatuses: [],
   },
   getters: {
      propositionStatuses: (state) => state.propositionStatuses,
   },
   mutations: {
      SET_PROPOSITION_STATUSES(state, propositionStatuses: Array<PropositionStatus>) {
         state.propositionStatuses = propositionStatuses;
      },
   },
   actions: {
      async getPropositionStatuses(context, query: LocationQuery) {
         const response = await service.getPropositionStatuses(query);
         context.commit('SET_PROPOSITION_STATUSES', response.data);
         return response.data;
      },
   },
};

export default PropositionStatusStore;
